// extracted by mini-css-extract-plugin
export default {"filterBlock":"mimic___styles_filterBlock__bTcxk"};